import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import "./ProfessionalExperience.css";
import logo_AliceBob from "../assets/logos/AliceBob.png";
import logo_Tohoku from "../assets/logos/TohokuUniv.gif"
import logo_Corpy from "../assets/logos/Corpy.png"

const professionalExperienceData = [
  {
    company: "Corpy & Co.",
    logo: logo_Corpy,
    role: "Research Engineer Intern ",
    description:
      "Conducted research projects in collaboration with top automobile companies. Designed AI models for speed estimation, human detection and pose estimation using explainable algorithms.",
    duration: "Dec. 2022 - Jun. 2024",
    location: "Tokyo, Japan",
    link: "https://corpy.co.jp/",
    borderless: true,
  },
  {
    company: "Tohoku University",
    logo: logo_Tohoku,
    role: "Teaching Assistant",
    description:
      "Taught fundamental principles of Computer Vision to undergraduates using interactive Python code.",
    duration: "Sep. 2023 - Feb. 2024",
    location: "Sendai, Japan",
    link: "https://www.eng.tohoku.ac.jp/english/academics/studies/graduate/communication.html",
    borderless: true,
  },
  {
    company: "Alice & Bob",
    logo: logo_AliceBob,
    role: "Software Engineer Intern",
    description:
      "Developed a Python API to streamline chip design processes for quantum computing applications. Implemented advanced 3D object manipulation tools and efficient pathfinding algorithms to optimize workflows and enhance design efficiency.",
    duration: "Apr. 2022 - Aug. 2022",
    location: "Paris, France",
    link: "https://alice-bob.com/",
    borderless: true,
  },
];

const ProfessionalExperience = () => (
  <section
    id="professional-experience"
    className="professional-experience-section"
  >
    <h2>Professional Experience</h2>
    {professionalExperienceData.map((experience, index) => (
      <div key={index} className="professional-experience-card">
        <div
          className={`professional-logo ${
            experience.borderless ? "borderless" : ""
          }`}
        >
          <img src={experience.logo} alt={`${experience.company} logo`} />
        </div>
        <div className="professional-details">
          <p className="professional-role">{experience.role}</p> {/* Larger, Emphasized Role */}
          <h4>
            {experience.company}
            {experience.link && (
              <a
                href={experience.link}
                target="_blank"
                rel="noopener noreferrer"
                className="company-link"
                title={`Visit ${experience.company}`}
              >
                <FaExternalLinkAlt />
              </a>
            )}
          </h4>
          <p className="professional-description">{experience.description}</p>
          <div className="professional-meta">
            <span className="professional-duration">{experience.duration}</span> |
            <span className="professional-location">{experience.location}</span>
          </div>
        </div>
      </div>
    ))}
  </section>
);

export default ProfessionalExperience;
